import { fetchOneEntry } from "../../functions/get-content/index.qwik.mjs";
import { logger } from "../../helpers/logger.qwik.mjs";
const fetchSymbolContent = async ({ builderContextValue, symbol }) => {
  if ((symbol == null ? void 0 : symbol.model) && // This is a hack, we should not need to check for this, but it is needed for Svelte.
  (builderContextValue == null ? void 0 : builderContextValue.apiKey))
    return fetchOneEntry({
      model: symbol.model,
      apiKey: builderContextValue.apiKey,
      apiVersion: builderContextValue.apiVersion,
      ...(symbol == null ? void 0 : symbol.entry) && {
        query: {
          id: symbol.entry
        }
      }
    }).catch((err) => {
      logger.error("Could not fetch symbol content: ", err);
      return void 0;
    });
  return void 0;
};
export {
  fetchSymbolContent
};
